<script setup>
import Alert from '@/Components/Alert.vue';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import CustomerNavigation from '@/Pages/Customer/NavigationDropdown.vue';
import DarkMode from '@/Components/DarkMode.vue';
import GenericOfferLogo from '@/Images/GenericOfferLogo.vue';
import SwitchLocale from '@/Components/SwitchLocale.vue';
import { Link, usePage } from '@inertiajs/vue3';
import { markRaw, ref } from 'vue';

import { useCurrentUser } from 'vuefire';

import { locale } from '@/Localization.js';
import { trans, transChoice } from 'laravel-vue-i18n';

const props = defineProps({
    layout: { type: Object, },
    partner_slug: { type: String, },
    route_welcome: { type: String, },
    route_coupon: { type: String, },
    route_checkout: { type: String, },
});

const basename = (str) => {
    var base = new String(str).substring(str.lastIndexOf('/') + 1);
    if (base.lastIndexOf(".") != -1) {
        base = base.substring(0, base.lastIndexOf("."));
    }

    return base;
}

const layoutHeaderLogo = ref(null);
import HoppenLogo from '../../Images/HoppenLogo.vue';
import OrangeLogo from '../../Images/OrangeLogo.vue';
import PartenamutLogo from '../../Images/PartenamutLogo.vue';

const loadComponent = (view) => {

    var name = basename(view);

    if (name == 'HoppenLogo') {
        return markRaw(HoppenLogo);
    } else if (name == 'OrangeLogo') {
        return markRaw(OrangeLogo);
    } else if (name == 'PartenamutLogo') {
        return markRaw(PartenamutLogo);
    }

    return markRaw(GenericOfferLogo);
}

const user = useCurrentUser();

layoutHeaderLogo.value = props.layout && props.layout.header && props.layout.header.logo
    ? loadComponent(props.layout.header.logo)
    : markRaw(GenericOfferLogo)

usePage().props.primaryButtonCss = {
    bgColor: props.layout.colors.btn_primary_bg
};
</script>

<template>
    <!-- Pourquoi pb-36 dans la balise ci-dessous ? -->
    <div :class="{ 'min-h-screen pb-36': true, [`bg-[${layout.colors.bg}]`]: true, [`dark:bg-[${layout.colors.bg_dark}]`]: true }">
        <nav :class="[`bg-white dark:bg-[${layout.colors.background}] border-b border-gray-100 dark:border-gray-700`]">
            <!-- Primary Navigation Menu -->
            <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

                <div class="pt-6 pb-2 group relative text-center">

                    <Link :href="route(route_welcome, { 'locale': locale, 'partner_slug': partner_slug })" aria-label="Accueil" class="inline">
                    <template v-if="layoutHeaderLogo">
                        <layoutHeaderLogo class="inline-block h-9 fill-current dark:text-white ml-2" />
                    </template>
                    <ApplicationLogo v-else class="inline-block h-9 fill-current dark:text-white ml-2" />
                    </Link>

                    <p v-if="layout && layout.header && typeof layout.header.tagline != 'undefined'" class="mt-4 mb-3 dark:text-white" v-html="trans(layout.header.tagline)"></p>
                    <p v-else class="mt-4 mb-3 dark:text-white">
                        <span class="block md:inline">{{ trans("Bienvenue dans la page d'inscription") }}</span> MeditBe
                    </p>

                </div>
            </div>
        </nav>

        <div v-if="user" class="absolute top-3 right-1">
            <nav class="flex pt-6 px-10 right-0 absolute z-[9999]">
                <div class="absolute top-3 right-4">
                    <CustomerNavigation />
                </div>
            </nav>
        </div>

        <!-- Page Heading -->
        <!-- <header class="bg-white dark:bg-gray-800 shadow" v-if="$slots.header">
                <div class="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <slot name="header" />
                </div>
            </header> -->

        <!-- Flash Message -->
        <div v-if="$page.props.flash.message" class="max-w-4xl mx-auto">
            <Alert :show="!!$page.props.flash.message">
                <template #title>
                    Holy smokes!
                </template>
                {{ $page.props.flash.message }}
            </Alert>
        </div>

        <!-- Page Content -->
        <main>
            <div class="max-w-4xl mx-auto">
                <div class="overflow-hidden">
                    <div :class="{ 'py-8 px-6': true, [`text-[${layout.colors.txt_default}]`]: true, 'dark:text-gray-100': true }">
                        <slot />
                    </div>
                </div>
            </div>
        </main>
        <!-- Pourquoi pb-32 dans la balise ci-dessous ? -->
        <div class="flex flex-row-reverse max-w-4xl mx-auto px-4 pb-32 sm:px-6 lg:px-8 text-slate-700 text-sm font-medium dark:text-slate-200">

            <a href="https://www.meditbe.com/" target="_blank" class="hover:text-slate-900 dark:hover:text-white" aria-label="Meditbe.com">
                <ApplicationLogo class="block h-6 w-auto fill-current dark:text-white" />
            </a>

            <div v-if="layout && (layout.show_btn_dark_mode || layout.show_btn_switch_locale)" class="w-full flex  text-slate-600">
                <div class="flex gap-3">
                    <DarkMode v-if="layout.show_btn_dark_mode" />
                    <SwitchLocale v-if="layout.show_btn_switch_locale" />
                </div>
                <!-- <template v-if="user">
                    <div class="mx-4 text-gray-300 dark:text-gray-300">
                        |
                    </div>
                    <div class="flex items-center mr-auto text-gray-400">
                        <div>
                            <span class="font-bold mr-2">UID:</span>
                            <span class="font-thin">{{ user.uid }}</span>
                        </div>
                    </div>
                </template> -->
            </div>

        </div>
    </div>
</template>